










































import { Component, Prop, Vue } from 'vue-property-decorator'
import EyeIcon from '@/app/ui/assets/eye.vue'
import EyeDisabledIcon from '@/app/ui/assets/eye_disabled.vue'

@Component({
  name: 'PickupCorporateAddress',
  components: {
    EyeIcon,
    EyeDisabledIcon
  }
})
class PickupCorporateAddress extends Vue {
  @Prop({ type: String, required: true })
  readonly shipmentId!: string

  @Prop({ type: String, default: null })
  readonly addressDisplay!: string | null

  @Prop({ type: Boolean, required: true, default: false })
  readonly isRevealed!: boolean

  @Prop({ type: Boolean, default: false })
  readonly isRevealLoading!: boolean

  @Prop({ type: Number, default: 0 })
  readonly lat!: number

  @Prop({ type: Number, default: 0 })
  readonly lon!: number

  handleToggle(): void {
    if (this.isRevealed) {
      this.$emit('hide-address', { shipmentId: this.shipmentId })
    } else {
      this.$emit('reveal-address', { shipmentId: this.shipmentId })
    }
  }

  get googleMapsUrl(): string {
    if (this.lat !== 0 && this.lon !== 0) {
      return `https://www.google.com/maps?q=${this.lat},${this.lon}`
    }

    if (this.addressDisplay) {
      return `https://www.google.com/maps?q=${encodeURIComponent(this.addressDisplay)}`
    }
    return '#'
  }
}

export default PickupCorporateAddress
